import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { BarberId } from '../data/business';
type BookingContextValue = {
  /** Selected barber, or null when the client has no preference. */
  barberId: BarberId | null;
  setBarberId: (id: BarberId | null) => void;
  /** Picks a barber and scrolls the client down to the booking form. */
  bookWithBarber: (id: BarberId) => void;
};
const BookingContext = createContext<BookingContextValue | null>(null);
export function BookingProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [barberId, setBarberId] = useState<BarberId | null>(null);
  const bookWithBarber = useCallback((id: BarberId) => {
    setBarberId(id);
    const target = document.getElementById('agendar');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, []);
  const value = useMemo<BookingContextValue>(() => ({
    barberId,
    setBarberId,
    bookWithBarber
  }), [barberId, bookWithBarber]);
  return <BookingContext.Provider value={value} data-id="element-312" data-mp="i364srmhcg06">{children}</BookingContext.Provider>;
}
export function useBooking(): BookingContextValue {
  const ctx = useContext(BookingContext);
  if (!ctx) {
    throw new Error('useBooking debe usarse dentro de BookingProvider');
  }
  return ctx;
}